/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_SubtitleInputs */

const cs_projects_subtitle = /** @type {(inputs: Projects_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developerské projekty pro Sreality. Inzeráty se napojují přes RK ID projektu.`)
};

const en_projects_subtitle = /** @type {(inputs: Projects_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer projects for Sreality. Listings attach via project RK ID.`)
};

/**
* | output |
* | --- |
* | "Developer projects for Sreality. Listings attach via project RK ID." |
*
* @param {Projects_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_subtitle = /** @type {((inputs?: Projects_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_subtitle(inputs)
	return cs_projects_subtitle(inputs)
});